import { RepositoryFactory } from '../../RepositoryFactory';
import Vue from 'vue';
const profiles = new RepositoryFactory('profiles');

export default {
  namespaced: true,
  state: {
    // Single class
    profile: {},
    profiles: [],
    allProfiles: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
  },
  getters: {
    currentPage(state) {
      return state.currentPage;
    },
    getProfile(state) {
      return state.profile;
    },
    getProfiles(state) {
      return state.profiles;
    },
    getAllProfiles(state) {
      return state.allProfiles;
    },
    getProfilesTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
  },
  mutations: {
    SET_PROFILE(state, data) {
      state.profile = data;
    },
    SET_PROFILES(state, data) {
      state.profiles = data.items;
      state.total = data.totalOfItems;
      state.totalPages = data.pageCount || 0;
    },
    SET_ALL_PROFILES(state, data) {
      state.allProfiles = data;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page, payload) => {
      commit('SET_PAGE', page);
      dispatch('getProfiles');
    },
    resetPagination: async ({ commit, dispatch }) => {
      commit('SET_PAGE', 1);
      dispatch('getProfiles');
    },
    searchProfile: async ({ commit }, payload) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await profiles.getWithSearch(payload.search, payload.extraParams, payload.page, payload.limit);
        commit('SET_PROFILES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    update: async ({ dispatch }, payload) => {
      try {
        await profiles.update(payload.id, payload.params);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Pergunta atualizada com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
      dispatch('getProfiles');
    },
    remove: async ({ dispatch }, id) => {
      try {
        const { data } = await profiles.delete(id);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Pergunta removida com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
      dispatch('getProfiles');
    },
    create: async ({ commit, dispatch }, payload) => {
      try {
        const res = await profiles.create(payload);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Pergunta criada com sucesso!',
        });
        dispatch('getProfiles');
        return res.data.id;
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: 'Erro: essa pergunta já existe',
        });
      }
    },
    getProfileById: async ({ commit }, id) => {
      try {
        const { data } = await profiles.getById(id);
        commit('SET_PROFILE', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
    },
    getAllProfiles: async ({ commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await profiles.get();
        commit('SET_ALL_PROFILES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getProfiles: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await profiles.get(state.currentPage);
        commit('SET_PROFILES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
